import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import {
  SbeSmsApiService,
  type BalanceResponseDto,
  type CheckoutRequestDto,
  type CheckoutResponseDto,
  type CreditOfferDto,
  type CreditsHistoryResponseDto,
  type CreditsOrdersResponseDto,
} from '@sbe-spinoff-client/sbe-sms-api';

/**
 * org 라우트(`orgId` 있음)는 URL이 `/orgs/:orgId/...`이라 `spinoffAuthInterceptor`가
 * `resolveOrgScopedId`로 자동 인식해 org access token을 붙인다(2026-07-23).
 */
@Injectable({ providedIn: 'root' })
export class CreditsApiService {
  private readonly api = inject(SbeSmsApiService);

  getOffers(): Observable<CreditOfferDto[]> {
    return this.api.creditsOffersControllerGetOffers<CreditOfferDto[]>();
  }

  checkout(body: CheckoutRequestDto, orgId?: string): Observable<CheckoutResponseDto> {
    return orgId
      ? this.api.orgCreditsCheckoutControllerCheckout<CheckoutResponseDto>(orgId, body)
      : this.api.creditsCheckoutControllerCheckout<CheckoutResponseDto>(body);
  }

  getBalance(orgId?: string): Observable<BalanceResponseDto> {
    return orgId
      ? this.api.orgBalanceControllerGetBalance<BalanceResponseDto>(orgId)
      : this.api.balanceControllerGetBalance<BalanceResponseDto>();
  }

  getHistory(
    params: { offset?: number; limit?: number; createdFrom?: string; createdTo?: string } = {},
    orgId?: string,
  ): Observable<CreditsHistoryResponseDto> {
    return orgId
      ? this.api.orgCreditsHistoryControllerGetHistory<CreditsHistoryResponseDto>(orgId, params)
      : this.api.creditsHistoryControllerGetHistory<CreditsHistoryResponseDto>(params);
  }

  getOrders(
    params: { page?: number; size?: number } = {},
    orgId?: string,
  ): Observable<CreditsOrdersResponseDto> {
    return orgId
      ? this.api.orgCreditsOrdersControllerGetOrders<CreditsOrdersResponseDto>(orgId, params)
      : this.api.creditsOrdersControllerGetOrders<CreditsOrdersResponseDto>(params);
  }
}
